module.exports = __webpack_public_path__ + "static/media/18_tn.3cae7eee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/18_tn.jpg
// module id = 506
// module chunks = 0